var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"page-grants"}},[_c('h5',{staticClass:"m-4 page-header"},[_vm._v(" >> "+_vm._s(_vm.$t('AUTH.MENU.GRANT')))]),(_vm.isTopCompany)?_c('GrantTopCompanyView'):_c('GrantApplicationView')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }